<template>
  <div class="listing">
    <tips class="listing-tip">
      <div class="listing-tip__line"> 1.会员首先在“设置/每月汇总日期设置”目录页内预设汇总日期，然后在“汇总/上传汇总报告”目录页内严格按照设定的日期及时上传对应数据报告，以下Listing信息将自动进行汇总更新； </div>
      <div class="listing-tip__line"> 2. 此处只创建"子ASIN"的Listing信息，“父ASIN”的Listing信息将在上传汇总数据报告后自动合并统计；当以下某列项未有显示相应数据则表示该列汇总功能暂未开通！ </div>
    </tips>
    <div class="listing-top">
      <div class="listing-top__title">Lisitng管理</div>
      <div class="listing-top__right">
        <div class="listing-top__name">店铺:</div>
        <el-select v-model="searchData.store" class="listing-top__select" size="mini" placeholder="全部店铺"></el-select>
        <div class="listing-top__name">国家站点:</div>
        <el-select v-model="searchData.country" class="listing-top__select" size="mini" placeholder="全部国家"></el-select>
        <el-input v-model="searchData.asin" size="mini" placeholder="可输入产品标贴，名称，ASIN等查询"></el-input>
        <div class="listing-top__btn" @click="getListingList">查询</div>
        <div class="listing-top__btn" @click="newListingBtnClick">新建Listing</div>
      </div>
    </div>
    <div class="listing-table">
      <Table
        :head="listingTableHead"
        :body="listingList"
        @deleteData="deleteTableData"
        @changeData="changeTableData"
        width="1654"
        height="550"></Table>
    </div>
  </div>
</template>

<script>
import Table from 'components/common/Table.vue'
import tips from '../common/tips.vue';
import ProductAxios from 'service/product';
import { ListingSearch, Listing, ListingNewModule } from './class';
export default {
  name: 'listing',
  components: {
    tips, Table
  },
  data(){
    return {
      searchData: new ListingSearch(),
      listingList: [],
      listingTableHead: ListingNewModule.NEWLISTINGTABLEHEAD()
    }
  },
  methods:{
    /**获取listing列表 */
    async getListingList(){
      this.listingList.splice(0, this.listingList.length)
      let res = await ProductAxios.getListingList(this.searchData.getListingListAxiosBody)
      if(res.data.code != 1){
        this.$message.error(res.data.info)
        return
      }
      this.$message.success('查询成功')
      let array = res.data.info
      array.map(obj => {
        let listingTemp = new Listing()
        listingTemp.backendListDataParsing(obj)
        listingTemp.finishStatus = '已对应更新'
        this.listingList.push(listingTemp)
      })
    },
    /**删除数据 */
    async deleteTableData(index){
      let id = this.listingList[index].listingId
      let res = await ProductAxios.deleteListing(id)
      if(res.data.code === 1){
        this.$message.success(res.data.info)
        this.listingList.splice(index, 1)
      }else{
        this.$message.error(res.data.info)
      }
    },
    /**修改数据 */
    changeTableData(index){
      this.$emit('go', {
        id: 'newListing',
        name: this.listingList[index].asin,
        index: index,
        obj: {
          type: 'change',
          id: this.listingList[index].listingId,
          value: JSON.stringify(this.listingList[index])
        }
      })
    },
    /**新建listing */
    newListingBtnClick(){
      this.$emit('go', {
        id: 'newListing',
        name: '新建商品Listing',
      })
    }
  },
  created(){
    this.getListingList()
  }
}
</script>

<style lang="scss" scoped>
.listing{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin:  10px;
    ::v-deep{
      .el-input__inner{
        width: 240px;
      }
      .el-input{
        width: 240px;
        margin-left: 10px;
      }
    }
    &__title{
      color: black;
      font-weight: bold;
      font-size: 18px;
    }
    &__select{
      ::v-deep{
        .el-input__inner{
          width: 110px;
        }
        .el-input{
          width: 110px;
        }
      }
    }
    &__right{
      display: flex;
      align-items: center;
    }
    &__name{
      text-align: end;
      margin-left: 5px;
    }
    &__btn{
      margin-left: 10px;
      padding: 0 10px;
      height: 28px;
      line-height: 28px;
      color: white;
      background: #00a0c7;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
